<template>
            <v-form v-model="valid">
    <v-container>
  <v-card
    class="mx-auto my-12"
    max-width="2000"
  >

 <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

    </v-col>

     <v-col cols="12" md="7" sm="1">  <!--  form titlte section   {{ formTitle }}-->
   <b>  Pagamento de   <span>Emolumentos</span> <v-icon large color="primary" >add_shopping_cart</v-icon></b>
     </v-col>
      <v-col  cols="12" sm="1" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="addComprovativo()"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>
  </v-row>

                  </v-toolbar>

              </template>
               <v-card-title>Efectuar o pagamento</v-card-title>
    <v-card-text>
      <v-row
        align="center"
        class="mx-0"
      >
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>
      </v-row>
       <div>
    <v-alert v-if="sucess" type="success">
      Pagamento feito com sucesso.
    </v-alert>

    <v-alert v-if="err" type="error">
      O pagamento não foi feito com sucesso.
    </v-alert>
  </div>
<v-row >
  <v-progress-circular v-if="isLoading" class="v-progress-circular" style="color:blue"
      :size="50"
      :width="10"
      indeterminate
      color="blue"
    ></v-progress-circular>
    <v-col cols="12" sm="12" md="4">
                      <v-select
              v-model="editedItem.idinstituicao"
              :rules="obrigqtorioRules"
              item-value="idInstituicao"
              item-text="descricao"
              @change="filterAnoLectivo(editedItem.idinstituicao)"
              :items="instituicoes"
              filled
              color="blue-grey lighten-2"
              label="Instituicao"
            ></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="2">
                       <v-text-field
           v-model="editedItem.idanoLectivo"
           label="Ano Lectivo"
            filled
            disabled
          ></v-text-field>
            </v-col>
    <v-col  cols="12" md="2">
    <v-select
              v-model="editedItem.fkEmolumentos"
              item-value="pkemolumentos"
              item-text="nome"
              :items="emolumentos"
              @change="preco(editedItem.fkEmolumentos)"
              label="Nome do Emolumento"
            ></v-select>
          </v-col>
<v-col  cols="12" sm="1" md="2">
  <v-text-field
                        v-model="editedItem.preco"
                        disabled
                        prefix = 'kz'
                        label="Valor unitario"
                      ></v-text-field>
          </v-col>
          <v-col  cols="12" sm="1" md="2">
            <v-text-field
                        v-model="editedItem.pagamento"
                        :rules="ruleTextRequiredPagamento"
                        prefix = 'kz'
                        @change="quantidadeEmolumento()"
                        label="Valor Pago"
                      ></v-text-field>
                    </v-col>
 </v-row>
 <v-row>
   <v-col cols="12" sm="12" md="3">
                      <v-select
              v-model="editedItem.formaPagamento"
              :rules="obrigqtorioRules"
              item-value="pkforma_pagamento"
              item-text="descricao"
              :items="formaPagamentos"
              filled
              color="blue-grey lighten-2"
              label="Forma de Pagamento"
              return-object
            ></v-select>
                    </v-col>
                        <v-col cols="12" sm="12" md="3">
                      <v-select
              v-model="editedItem.banco"
              :rules="obrigqtorioRules"
              item-value="pkbanco"
              item-text="descricao"
              :items="bancos"
              filled
              color="blue-grey lighten-2"
              label="Banco de proveniência"
              return-object
            ></v-select>
                    </v-col>

                    <v-col  cols="12" sm="1" md="3">
               <v-text-field
                        v-model="editedItem.Ordem_deposito"
                        :rules="obrigqtorioRules"
                        label="Ordem de deposito"
                      ></v-text-field>
                      <span style="color:red" v-if="duplicated">Ordem de deposito já existente </span>
  </v-col>
                                  <v-col cols="12" md="3">
          <v-menu
         ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date_"
        :rules="obrigqtorioRules"
        label="Data de depósito"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date_"
      max="2040-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
                       </v-col>
                        <v-col  cols="12" sm="1" md="2">
         <v-text-field
                        v-model="editedItem.quantidade"
                        disabled
                        label="Quantidade"
                      ></v-text-field>
                        </v-col>
                         <v-col  cols="12" sm="1" md="2">
                         <v-text-field
                        v-model="editedItem.resto"
                        disabled
                        label="Troco"
                      ></v-text-field>
                        </v-col>
                         <v-col  cols="12" sm="1" md="2">
                         <v-text-field
                        v-model="editedItem.pagamento"
                        disabled
                        label="Total Pago"
                      ></v-text-field>
                        </v-col>

  <!--
  <v-col cols="12" md="3">
   <template>
  <v-menu
    ref="menubi"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.data"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de deposito"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2025-12-31"
      min="1950-01-01"
      v-model="date_"
    ></v-date-picker>
  </v-menu>
  </template>
</v-col>
-->
          </v-row>
    </v-card-text>

  </v-card>
             </v-container>
  </v-form>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  directives: { mask },
  data: () => ({
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    ruleTelefone: [
      value => value.length === 9 || 'Minimo de caracteres exigido( 9 ).'
    ],
    duplicated: false,
    comprovativo: 0,
    menu: false,
    date_: null,
    valid: true,
    sucess: false,
    err: false,
    isLoading: false,
    instituicoes: [],
    emolumentos: [],
    anoLectivo: [],
    emolumentosAll: [],
    formaPagamentos: [],
    bancos: [],
    editedItem: {
      pkpagamentoEmolumento: 0,
      nome: '',
      idanoLectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: 0,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: ''

    },
    defaultItem: {
      pkpagamentoEmolumento: 0,
      nome: '',
      anolectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: 0,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: ''

    }
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    this.initializeEmolumentos()
    this.initializeAnoLectivo()
    this.initializeformapagamento()
    this.initializebanco()
  },

  methods: {
    async initializebanco () {
      this.isLoading = true
      try {
        this.bancos = await axios
          .get('/listarbancos')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeformapagamento () {
      this.isLoading = true
      try {
        this.formaPagamentos = await axios
          .get('/listarformapagamentos')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeAnoLectivo () {
      this.isLoading = true
      try {
        this.instituicoes = await axios
          .get('/anoLectivoInstituicao')
          .then(res => res.data)
        this.instituicoes.unshift({ 'idInstituicao': 0, 'idanolectivo': 0, 'idanolectivoInstituicao': 0, 'anolectivo': '', 'descricao': 'Selecione a instituição desejada' })
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    filterAnoLectivo (idinstituicao) {
      this.editedItem.idanoLectivo = this.instituicoes.filter(t => t.idInstituicao === idinstituicao)[0].anolectivo
      this.editedItem.instituicaodescricao = this.instituicoes.filter(t => t.idInstituicao === idinstituicao)[0].descricao
    },
    async initializeEmolumentos (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }

        this.emolumentos = await axios
          .get('/emolumentosAll/' + payload)
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    preco (pkemolumento) {
      this.editedItem.preco = this.emolumentos.filter(t => t.pkemolumentos === pkemolumento)[0].preco
      this.editedItem.nome = this.emolumentos.filter(t => t.pkemolumentos === pkemolumento)[0].nome
    },
    quantidadeEmolumento () {
      if (this.editedItem.pagamento) {
        this.editedItem.quantidade = parseInt(this.editedItem.pagamento / this.editedItem.preco)
        this.editedItem.resto = (this.editedItem.pagamento % this.editedItem.preco)
        this.editedItem.consumo = 0
      } else { this.editedItem.quantidade = 0 }
    },
    async addComprovativo () {
      let params =
       {
         pkcomprovativo_pagamento: 0,
         fkFormaPagamento: this.editedItem.formaPagamento.pkforma_pagamento,
         num_Deposito: this.editedItem.Ordem_deposito,
         idbanco: this.editedItem.banco.pkbanco,
         bancodescricao: this.editedItem.banco.descricao,
         data_deposito: this.date_,
         idpessoa: ls.get('idPessoa')
       }

      try {
        this.isLoading = true
        this.comprovativo = await axios
          .post('/comprovativopagamentoInsertOrUpdate', params)
          .then(res => res.data)

        this.isLoading = false
        this.text = this.comprovativo.data
        if (this.comprovativo.data.includes('sucesso')) {
          this.save(this.comprovativo.result[0].id)
          this.sucess = true
          this.text = this.comprovativo.result.length + ' gravado(s) com sucesso'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })
          this.sucess = true
          setTimeout(() => {
            this.sucess = false
          }, 2000)
        } else
        if (this.comprovativo.data.includes('existente')) {
          this.text = this.comprovativo.data
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
          this.duplicated = true
          setTimeout(() => {
            this.duplicated = false
          }, 5000)
        }
      } catch (error) {
        this.err = true
        console.log('eroooo: ' + error)
        this.isLoading = false
        this.text = error.message
        setTimeout(() => {
          this.err = false
        }, 5000)
      }
      this.$store.dispatch('textMessage', {
        msg: this.text,
        classMessage: 'msgError',
        timeout: 8000
      })
    },

    async save (idComprovativo) {
      this.isLoading = true
      if (this.editedItem.idinstituicao && this.editedItem.fkEmolumentos && this.editedItem.pagamento && this.editedItem.Ordem_deposito) {
        var params = {
          num_Deposito: this.editedItem.Ordem_deposito,
          fkEmolumentos: this.editedItem.fkEmolumentos,
          tipo_emolumento: this.editedItem.nome,
          pagamento: this.editedItem.pagamento,
          anoLectivo: this.editedItem.idanoLectivo,
          quantidade_inicial: this.editedItem.quantidade,
          idinstituicao: this.editedItem.idinstituicao,
          instituicao: this.editedItem.instituicaodescricao,
          resto: this.editedItem.resto,
          preco: this.editedItem.preco,
          autor: ls.get('idPessoa'),
          comprovativo: idComprovativo
        }

        try {
          let msg = await axios
            .post('/InsertPagarEmolumento', params)
            .then(res => res.data)
          this.isLoading = false
          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              this.sucess = true
              setTimeout(() => {
                this.sucess = false
                this.$router.push('/listarpagamentoemolumento')
              }, 2000)
            }
          } catch (error) {
            this.isLoading = false
            this.err = true
            setTimeout(() => {
              this.err = false
            }, 2000)
            this.text = error.message
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } finally {
            this.editedItem = this.defaultItem
            this.isLoading = false
          }
        } catch (error) {}
      } else this.isLoading = false
    }
  }
}

</script>
